/**
 * Ce que le produit livre réellement — LE seul endroit où l'illustration de la
 * landing prend ses chiffres.
 *
 * ⚠️ RÈGLE, la même que pour `social-proof.ts` : le visuel « After » du hero
 * montre un post boosté. Ce n'est pas une capture, c'est une illustration — mais
 * le nombre qu'elle affiche est lu comme une promesse par quelqu'un qui sort sa
 * carte. Il doit donc être celui que le service pose vraiment.
 *
 * La maquette Claude Design affichait 297 réactions et 24 commentaires. Le
 * service en pose 80 et 5. En plus d'être faux d'un facteur ~3,7, un saut de 3 à
 * 297 réactions est très exactement le « pic » que la page promet, deux
 * paragraphes plus bas, de ne jamais provoquer.
 *
 * SOURCE DE VÉRITÉ, côté API :
 *  - `NEVERZERO_BOOST_LEVEL = BoostLevels.ACCELERATE` et
 *    `NEVERZERO_NB_COMMENTS = 5`, dans `neverzero-provisioning.service.ts` ;
 *  - la taille effective de la vague vient de
 *    `AUTO_ENGAGEMENT_REACTION_TARGETS` (`backend-lib/src/types/ws-types.ts`),
 *    pas de `BOOST_SIZES` : `engagement.service.ts` écrase la taille par
 *    `getAutoEngagementReactionTarget()` dès que la source est `AUTO_BOOST`, ce
 *    qui est toujours le cas ici. ACCELERATE y vaut **80**, pas 100.
 *
 * Ces valeurs sont recopiées plutôt qu'importées : une app Vite n'importe jamais
 * le baril `@backend-lib` (un `export *` imbriqué casse le build Rollup de
 * prod). Le coût de la recopie est ce commentaire ; en échange, le chiffre
 * affiché reste vérifiable ligne à ligne.
 */

/**
 * Réactions posées sur chaque post — `AUTO_ENGAGEMENT_REACTION_TARGETS.ACCELERATE`.
 * C'est la vague de croisière : un client neuf démarre à 20 et y monte sur
 * 60 jours (`apps/front-api/src/neverzero/neverzero-warmup.ts`).
 */
export const WAVE_REACTIONS = 80;

/** Commentaires demandés par post — `NEVERZERO_NB_COMMENTS`. */
export const WAVE_COMMENTS = 5;

/**
 * Le lancement que personne ne voit, cité par la section Focus (« A launch
 * stuck at 10 likes… »). Le visuel avant/après qui l'affichait a été retiré
 * avec la section « paradoxe » le 01/10/2026, à la demande de Stephen.
 */
export const BEFORE_REACTIONS = 10;
